import fc from "@/firebaseConfig";
import firebase from "firebase/app";

const _ = require("lodash");
const axios = require("axios");

export default {
  namespaced: true,
  state: {
    list: [{ company: {} }],
    selectedCompany: { nameTH: "", imageLogoUrl: "" },
    selectedCompanyAutoDocConfig: [],
    selectedCompanyApPrompts: [],
    selectedCompanyApVendors: [],
    selectedChatGptActivityLog: [],
    selectedDateChatGptActivityLog: [],
    selectedDateDetailChatGptActivityLog: [],
    selectedCompanyProductList: {},
    branchList: [],
    selectedBranch: "",
    loading: false,
    sendEmailType: "0",
    addUserPermission: "owner",
    newCompany: null,
    companyDetail: { address: {} },
    isOpenModalCompany: false,
    companyIDModal: "",
    uploadLogoState: null,
    loadingUpdate: false,
    uploadCompanyStatus: null,
    companyPlan: null,
    companyNextPlan: null,
    refCodeObject: null,
    alertRefCode: {
      isShow: false,
      alertStatus: "",
    },
    companyUsage: { countsDocsAll: 0 },
    companyAddress: {
      addressNo: "",
      building: "",
      village: "",
      alley: "",
      street: "",
      province: "",
      district: "",
      subDistrict: "",
      postCode: "",
    },
    companyCerRequest: {
      price: "",
      requestCertificate: false,
      requestDigitalSignature: false,
      service: true,
      requestERPConnect: false,
    },
    sendEmailDelay: 0,
    isProductListLoading: true,
    unsubscribeApVendors: null,
    unsubscribeAutoDocConfig: null,
  },
  mutations: {
    setUnsubscribeAutoDocConfig(state, unsubscribe) {
      state.unsubscribeAutoDocConfig = unsubscribe;
    },
    clearUnsubscribeAutoDocConfig(state) {
      state.unsubscribeAutoDocConfig = null;
    },
    removeVendor(state, vendorId) {
      state.selectedCompanyApVendors = state.selectedCompanyApVendors.filter(
        (vendor) => vendor.vendorId !== vendorId
      );
    },
    setCompanies(state, val) {
      state.list = val;
    },
    setProductListLoading(state, val) {
      state.isProductListLoading = val; // Set the flag to true
    },
    setSelectedCompany(state, val) {
      state.selectedCompany = val;
    },
    setSelectedCompanyAutoDocConfig(state, val) {
      state.selectedCompanyAutoDocConfig = val;
    },
    setSelectedCompanyApPrompts(state, val) {
      state.selectedCompanyApPrompts = val;
    },
    setSelectedCompanyApVendors(state, val) {
      state.selectedCompanyApVendors = val;
    },
    setSelectedChatGptActivityLog(state, val) {
      state.selectedChatGptActivityLog = val;
    },
    setSelectedDateChatGptActivityLog(state, val) {
      state.selectedDateChatGptActivityLog = val;
    },
    setSelectedDateDetailChatGptActivityLog(state, val) {
      state.selectedDateDetailChatGptActivityLog = val;
    },
    setSelectedCompanyProductList(state, val) {
      state.selectedCompanyProductList = val;
    },
    setSelectedBranch(state, val) {
      state.selectedBranch = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingUpdate(state, val) {
      state.loadingUpdate = val;
    },
    setSendEmailType(state, val) {
      state.sendEmailType = val;
    },
    setSendEmailDelay(state, val) {
      state.sendEmailDelay = val;
    },
    setAddUserPermission(state, val) {
      state.addUserPermission = val;
    },
    setNewCompany(state, val) {
      state.newCompany = val;
    },
    setCompanyDetail(state, val) {
      state.companyDetail = val;
    },
    setBranchList(state, val) {
      state.branchList = val;
    },
    setIsOpenModalCompany(state, val) {
      state.isOpenModalCompany = val;
    },
    setCompanyIDModal(state, val) {
      state.companyIDModal = val;
    },
    setUploadLogoState(state, val) {
      state.uploadLogoState = val;
    },
    uploadUserPDFFile(state, val) {
      state.uploadLogoState = val;
    },
    setUploadCompanyStatus(state, val) {
      state.uploadCompanyStatus = val;
    },
    setCompanyPlan(state, val) {
      state.companyPlan = val;
    },
    setRefCodeObject(state, val) {
      state.refCodeObject = val;
    },
    setAlertRefCode(state, val) {
      state.alertRefCode = val;
    },
    setCompanyNextPlan(state, val) {
      state.companyNextPlan = val;
    },
    setCompanyUsage(state, val) {
      state.companyUsage = val;
    },
    setCompanyAddress(state, val) {
      state.companyAddress = val;
    },
    setCompanyCerRequest(state, val) {
      state.companyCerRequest = val;
    },
    updateOpenAIApiKey(state, { OpenAIapiKey }) {
      state.selectedCompany = {
        ...state.selectedCompany,
        OpenAIapiKey: OpenAIapiKey,
      };
    },
    updateGoogleAIApiKey(state, { GoogleAIapiKey }) {
      state.selectedCompany = {
        ...state.selectedCompany,
         GoogleAIapiKey : GoogleAIapiKey,
      };
    },
    updateSettingModel(state, { primaryModelIndex,secondaryModelIndex }) {
      state.selectedCompany = {
        ...state.selectedCompany,
          primaryModelIndex: primaryModelIndex,
          secondaryModelIndex: secondaryModelIndex
      };
    },
    
    addPrompt(state, prompt) {
      state.selectedCompanyApPrompts.push(prompt);
    },

    updatePrompts(state, prompts) {
      console.log("yyyyyyyyyyyy",prompts)
      state.selectedCompanyApPrompts = prompts;
    },
    removePrompt(state, promptId) {
      state.selectedCompanyApPrompts = state.selectedCompanyApPrompts.filter(
        (p) => p.promptId !== promptId
      );
    },
    setUnsubscribeApVendors(state, unsubscribe) {
      state.unsubscribeApVendors = unsubscribe;
    },
    clearUnsubscribeApVendors(state) {
      state.unsubscribeApVendors = null;
    },
  },
  actions: {
    async fetchPrompts({ commit }, { companyId }) {
      const promptsSnapshot = await fc.companies
        .doc(companyId)
        .collection("PurchaseInvoicePrompts")
        .get();

      const prompts = promptsSnapshot.docs.map((doc) => ({
        promptId: doc.id,
        ...doc.data(),
      }));

      commit("setSelectedCompanyApPrompts", prompts);
    },
    async fetchApVendors({ commit, state }, { companyId }) {
      // Unsubscribe from any existing listener to prevent multiple listeners
      if (state.unsubscribeApVendors) {
        state.unsubscribeApVendors();
        commit("clearUnsubscribeApVendors");
      }
  
      try {
        // Set up a new real-time listener
        const unsubscribe = fc.companies
          .doc(companyId)
          .collection("PurchaseInvoiceVendors")
          .orderBy("venCode", "asc")
          .onSnapshot((querySnapshot) => {
            const vendors = querySnapshot.docs.map((doc) => ({
              vendorId: doc.id,
              venLabel: doc.data().venCode + " - " + doc.data().venName,
              ...doc.data(),
            }));
  
            commit("setSelectedCompanyApVendors", vendors);
          });
  
        // Save the unsubscribe function in state
        commit("setUnsubscribeApVendors", unsubscribe);
      } catch (error) {
        console.error("Error fetching real-time vendors:", error);
      }
    },
    unsubscribeApVendors({ commit, state }) {
      if (state.unsubscribeApVendors) {
        state.unsubscribeApVendors();
        commit("clearUnsubscribeApVendors");
      }
    },
    async deleteVendor({ commit }, { companyId, vendorId }) {
      try {
        // Delete vendor from Firestore
        await fc.companies
          .doc(companyId)
          .collection("PurchaseInvoiceVendors")
          .doc(vendorId)
          .delete();
    
        // Commit mutation to update local state
        commit("removeVendor", vendorId);
    
        return { success: true };
      } catch (error) {
        console.error("Error deleting vendor:", error);
        return { success: false, error };
      }
    },
    async updateOpenAIApiKey({ commit }, { companyId, OpenAIapiKey,GoogleAIapiKey }) {
      try{
      await fc.companies.doc(companyId).update({
        openAiKey: OpenAIapiKey,
      });
      commit("updateOpenAIApiKey", { OpenAIapiKey });
      }catch (error) {
        console.error("Error OpenAIapiKey :", error);
      }
    },
    async updateGoogleAIApiKey({ commit }, { companyId, OpenAIapiKey,GoogleAIapiKey }) {
      try{
      await fc.companies.doc(companyId).update({
         googleAIapiKey : GoogleAIapiKey,
      });
      commit("updateGoogleAIApiKey", { GoogleAIapiKey });
      }catch (error) {
        console.error("Error GoogleAIapiKey :", error);
      }
    },
    async updateSettingModel({ commit }, { companyId,primaryModelIndex,secondaryModelIndex }) {
      try{
      await fc.companies.doc(companyId).update({
         models:
         {
          mainmodel :primaryModelIndex,
          submodel :secondaryModelIndex
        } 
         
      });
      commit("updateSettingModel", { primaryModelIndex,secondaryModelIndex});
      }catch (error) {
        console.error("Error GoogleAIapiKey :", error);
      }
    },

    async addPrompt({ commit, state }, { companyId, prompt }) {
      const promptRef = await fc.companies
        .doc(companyId)
        .collection("PurchaseInvoicePrompts")
        .add(prompt);

      commit("addPrompt", {
        ...prompt,
        promptId: promptRef.id,
      });
    },
    async deletePrompt({ commit }, { companyId, promptId }) {
      await fc.companies
        .doc(companyId)
        .collection("PurchaseInvoicePrompts")
        .doc(promptId)
        .delete();

      commit("removePrompt", promptId);
    },

    async updatePrompts({ commit }, { companyId, prompts }) {
      const batch = fc.db.batch();
      prompts.forEach((prompt) => {
        const promptRef = fc.companies
          .doc(companyId)
          .collection("PurchaseInvoicePrompts")
          .doc(prompt.promptId);
        batch.update(promptRef, prompt);
      });
      await batch.commit();
      commit("updatePrompts", prompts);
    },
    getCompany({ commit }, { companyID }) {
      commit("setLoading", true);
      fc.companies
        .doc(companyID)
        .get()
        .then(function (companyDetail) {
          let company = companyDetail.data();
          console.log("company =",company);
          commit("setCompanyDetail", company);
        });
      commit("setLoading", false);
    },
    getList({ commit }) {
      commit("setLoading", true);
      let user = firebase.auth().currentUser;
      fc.db
        .collection("CompaniesUsers")
        .where("userID", "==", user.uid)
        .get()
        .then((companies) => {
          let companiesArray = [];
          companies.forEach((doc) => {
            let company = doc.data();
            company.id = doc.id;
            companiesArray.push(company);
          });
          companiesArray.sort((a, b) => {
            return a.company.nameTH.localeCompare(b.company.nameTH);
          });
          commit("setCompanies", companiesArray);
          commit("setLoading", false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompanyDetailSetting({ commit }, { id }) {
      commit("setLoading", true);
      fc.companies
        .doc(id)
        .get()
        .then(function (companyData) {
          let company = companyData.data();
          commit("setSendEmailType", company.sendEmailType || 0);
          commit("setSendEmailDelay", company.sendEmailDelay || 0);
          commit("setAddUserPermission", company.addUserPermission || "owner");
          commit("setLoading", false);
        });
    },
    getBranchList({ commit }, { companyId }) {
      fc.companies
        .doc(companyId)
        .collection("Branches")
        .get()
        .then((branchList) => {
          let branchListTmp = [];
          branchList.forEach((branch) => {
            branchListTmp.push(branch.id);
          });
          commit("setBranchList", branchListTmp);
        });
    },
    getCompanyAddress({ commit }, { companyID }) {
      commit("setLoading", true);
      fc.companies
        .doc(companyID)
        .get()
        .then(function (companyDetail) {
          let company = companyDetail.data();
          commit("setCompanyAddress", company["address"]);
        });
      commit("setLoading", false);
    },
    createCompany({ commit, dispatch }, { company, logo }) {
      commit("setLoading", true);
      let user = firebase.auth().currentUser;
      fc.companies
        .add(company)
        .then(async function (newCompany) {
          fc.users
            .doc(user.uid)
            .get()
            .then(function (user) {
              if (user.exists) {
                let userData = _.cloneDeep(user.data());
                userData.id = user.id;
                dispatch(
                  "user/addUserInCompany",
                  { companyId: newCompany.id, user: userData, role: "owner" },
                  { root: true }
                ).then(() => {
                  dispatch("updateCompanyLogo", {
                    logo: logo,
                    companyID: newCompany.id,
                    userID: userData.id,
                  });
                });
              }
            });
        })
        .catch(function (error) {
          console.log(error);
          commit("setNewCompany", "");
        });
    },
    updateCompanySetting({ commit }, { companyId, type, value }) {
      commit("setLoading", true);
      fc.companies
        .doc(companyId)
        .set({ [type]: value }, { merge: true })
        .then(function () {
          commit("setLoading", false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateCompanyWithUploadLogo(
      { commit, dispatch },
      { companyID, company, logo }
    ) {
      commit("setLoadingUpdate", true);
      fc.companies
        .doc(companyID)
        .set(company, { merge: true })
        .then(function () {
          if (logo) {
            dispatch("updateCompanyLogo", { logo: logo, companyID: companyID });
          } else {
            commit("setLoadingUpdate", false);
            commit("setUploadCompanyStatus", "success");
          }
        })
        .catch(function (error) {
          console.log(error);
          commit("setUploadCompanyStatus", "error");
        });
    },
    updateCompany({ dispatch }, { companyID, company, prefixes }) {
      let companyUpload = { ...company };
      delete companyUpload.imageLogoShow;
      delete companyUpload.imageLogoUrl;
      delete companyUpload.imageLogoPath;
      if (company.imageLogoUrl && typeof company.imageLogoUrl !== "string") {
        dispatch("updateCompanyWithUploadLogo", {
          companyID,
          company: companyUpload,
          logo: company.imageLogoUrl,
        });
      } else {
        dispatch("updateCompanyWithUploadLogo", {
          companyID,
          company: companyUpload,
        });
      }

      if (prefixes || (prefixes.length > 0 && companyID)) {
        console.log("prefixes -> ", prefixes);
        console.log("companyID -> ", companyID);
        const docRef = fc.companies
          .doc(companyID)
          .collection("Summaries")
          .doc("all");

        // Define the field path and the new value for the specific field
        const fieldPath = new firebase.firestore.FieldPath("prefixes"); // Replace 'field1' with your field name
        const newValue = prefixes;

        // Use the update method with the FieldPath to update the specific field
        docRef
          .update(fieldPath, newValue)
          .then(() => {
            console.log("Field successfully updated!");
          })
          .catch((error) => {
            console.error("Error updating field: ", error);
          });
      }
    },
    updateCompanyLogo({ commit }, { logo, companyID }) {
      let timeStamp = new Date().getTime();
      let userID = firebase.auth().currentUser.uid;
      let storageRef = firebase
        .storage()
        .ref(`Users/${userID}/Companies/${companyID}/Logos/${timeStamp}.jpg`);
      let uploadTask = storageRef.put(logo);
      uploadTask.on(
        "state_changed",
        function progress(snapshot) {
          let percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          commit("setUploadLogoState", percentage);
        },
        function error(err) {
          console.log(err);
        },
        function () {
          uploadTask.then((snapshot) => {
            snapshot.ref.getDownloadURL().then(() => {
              axios
                .get(
                  fc.getImageUrl +
                    "gs://" +
                    snapshot.ref.bucket +
                    "/" +
                    snapshot.ref.fullPath
                )
                .then(function (response) {
                  if (response && response.data && response.data.image_url) {
                    fc.companies
                      .doc(companyID)
                      .set(
                        {
                          imageLogoUrl: response.data.image_url,
                          imageLogoPath:
                            "gs://" +
                            snapshot.ref.bucket +
                            "/" +
                            snapshot.ref.fullPath,
                        },
                        { merge: true }
                      )
                      .then(function () {
                        commit("setLoading", false);
                        commit("setLoadingUpdate", false);
                        commit("setNewCompany", companyID);
                        commit("setUploadCompanyStatus", "success");
                      })
                      .catch(function (error) {
                        console.log(error);
                        commit("setUploadCompanyStatus", "error");
                      });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  commit("setUploadCompanyStatus", "error");
                });
            });
          });
        }
      );
    },
    uploadUserPDFFile({ commit }, { files, companyID }) {
      if (!Array.isArray(files) || files.length === 0) {
        console.error("No files to upload");
        return; // ไม่ทำงานถ้าไม่มีไฟล์
      }

      let userID = firebase.auth().currentUser.uid;
      console.log("userID::::",userID)
      let uploadedFiles = []; // เก็บ URL ของไฟล์ที่อัปโหลด

      files.forEach((file) => {
        let fileName = file.name; // ใช้ชื่อไฟล์เดิมที่ผู้ใช้เลือก
        console.log("fileName:::",fileName)
        let nameWithoutExtension  = fileName.split('.')[0]
        let storageRef = firebase
          .storage()
          .ref(`/Companies/${companyID}/PIsFiles/${fileName}`);

        let uploadTask = storageRef.put(file);
        uploadTask.on(
          "state_changed",
          function progress(snapshot) {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            commit("uploadUserPDFFile", percentage); // อัปเดตสถานะการอัปโหลด
          },
          function error(err) {
            console.log(err); // แสดงข้อผิดพลาดถ้ามี
          },
          function () {
            uploadTask.then((snapshot) => {
              const gsPath = snapshot.ref.toString()        

                    fc.companies                
                    .doc(companyID)
                    .collection('PurchaseInvoiceFiles')
                    .doc()
                    .set(
                        {
                          extension: 'pdf',
                          fileName: nameWithoutExtension,
                          fileType: 'DOCUMENT',
                          monthFolder: '2025-04',
                          pdfPath: gsPath,  // e.g., `gs://sld-etax.appspot.com/Companies/${companyID}/PDFTest/${fileName}`
                          physicalFileName: fileName,
                          physicalFilePath: '',
                          status: 'NEW',
                          timestamp: '',
                          uploadFrom: 'Client',
                        },
                      )
                    .then(() => {
                      commit("setLoading", false);
                      commit("setLoadingUpdate", false);
                      commit("setNewCompany", companyID);
                      commit("setUploadCompanyStatus", "success");
                    })
                    .catch((error) => {
                      console.log(error);
                      commit("setUploadCompanyStatus", "error");
                    });
            });
          }
        );
      });
    },

    setCompany({ commit }, { companyId }) {
      fc.companies
        .doc(companyId)
        .get()
        .then(function (companyData) {
          let companySelect = companyData.data();
          commit("setSelectedCompany", {
            ...companySelect,
            companyId: companyId,
          });
        });
    },
    getCompanyAutoDocConfig({ commit, state }, { companyId }) {
      // Unsubscribe if already listening
      if (state.unsubscribeAutoDocConfig) {
        state.unsubscribeAutoDocConfig();
        commit("clearUnsubscribeAutoDocConfig");
      }
  
      const unsubscribe = fc.companies
        .doc(companyId)
        .collection("PurchaseOrderSettings")
        .where("isActive", "==", true)
        .onSnapshot(
          (snapshot) => {
            const configs = snapshot.docs.map(doc => doc.data());
            commit("setSelectedCompanyAutoDocConfig", configs);
          },
          (error) => {
            console.log("Real-time error:", error);
          }
        );
  
      commit("setUnsubscribeAutoDocConfig", unsubscribe);
    },
    unsubscribeAutoDocConfig({ commit, state }) {
      if (state.unsubscribeAutoDocConfig) {
        state.unsubscribeAutoDocConfig();
        commit("clearUnsubscribeAutoDocConfig");
      }
    },
    getChatGptActivityLog({ commit, dispatch }, { companyId }) {
      // console.log("Fetching ChatGptActivityLog...");
      fc.companies
        .doc(companyId)
        .collection("ChatGptActivityLog")
        .get()
        .then(function (activityLogData) {
          const selectedChatGptActivityLog = activityLogData.docs.map((doc) => {
            return { id: doc.id, ...doc.data() };
          });
          commit("setSelectedChatGptActivityLog", selectedChatGptActivityLog);
        })
        .catch(function (error) {
          console.log("Error fetching ChatGptActivityLog: ", error);
        });
    },
    getDateListChatGptActivityLog({ commit, dispatch }, { companyId, newVal }) {
      // console.log("Fetching Date ChatGptActivityLog...");
      commit("setLoading", true);
      fc.companies
        .doc(companyId)
        .collection("ChatGptActivityLog")
        .doc(newVal)
        .collection("Dates")
        .get()
        .then(function (doc) {
          if (doc.docs.length) {
            const selectedDateChatGptActivityLog = doc.docs.map((d) => {
              return { id: d.id, ...d.data() };
            });
            commit(
              "setSelectedDateChatGptActivityLog",
              selectedDateChatGptActivityLog
            ); // Assuming there's a mutation named "setChatGptActivityLog"
            commit("setLoading", false);
          } else {
            const selectedDateChatGptActivityLog = [];
            commit(
              "setSelectedDateChatGptActivityLog",
              selectedDateChatGptActivityLog
            );
            commit("setLoading", false);
            //console.log("No data found for the specified date.");
          }
        })
        .catch(function (error) {
          console.log("Error fetching ChatGptActivityLog: ", error);
          commit("setLoading", false);
        });
    },

    getDateDetailChatGptActivityLog(
      { commit, dispatch },
      { companyId, month, day }
    ) {
      //console.log("Fetching Date ChatGptActivityLog...",companyId, month , day);
      commit("setLoading", true);
      fc.companies
        .doc(companyId)
        .collection("ChatGptActivityLog")
        .doc(month)
        .collection("Dates")
        .doc(day)
        .collection("Details")
        .get()
        .then(function (doc) {
          if (doc.docs.length > 0) {
            const selectedDateDetailChatGptActivityLog = doc.docs.map((d) => {
              return { id: d.id, ...d.data() };
            });
            commit(
              "setSelectedDateDetailChatGptActivityLog",
              selectedDateDetailChatGptActivityLog
            ); // Assuming there's a mutation named "setChatGptActivityLog"
            commit("setLoading", false);
          } else {
            const selectedDateDetailChatGptActivityLog = [];
            commit(
              "setSelectedDateDetailChatGptActivityLog",
              selectedDateDetailChatGptActivityLog
            );
            commit("setLoading", false);
            //console.log("No data found for the specified date.");
          }
        })
        .catch(function (error) {
          console.log("Error fetching ChatGptActivityLog: ", error);
          commit("setLoading", false);
        });
    },
    async getCompanyProductList({ commit }, { companyId }) {
      try {
        commit("setLoading", true);
        // console.log('object')
        const companySettingDoc = await fc.companies
          .doc(companyId)
          .collection("ProductList")
          .doc("PSC")
          .get();

        const companyProductList = companySettingDoc.data() || {};
        commit("setSelectedCompanyProductList", companyProductList);
      } catch (error) {
        console.error("Error fetching company product list:", error);
      } finally {
        commit("setLoading", false);
        commit("setProductListLoading", false);
      }
    },
    setSelectedBranch({ commit }, { branch }) {
      commit("setSelectedBranch", branch);
    },
    setNewCompanyEmpty({ commit }) {
      commit("setNewCompany", null);
    },
    setIsOpenModalCompany({ commit }, { isOpenModal }) {
      commit("setIsOpenModalCompany", isOpenModal);
    },
    setCompanyIDModal({ commit }, { companyIDModal }) {
      commit("setCompanyIDModal", companyIDModal);
    },
    setOpenModalCompany({ commit }, { companyIDModal }) {
      commit("setIsOpenModalCompany", true);
      commit("setCompanyIDModal", companyIDModal);
    },
    setCloseModalCompany({ commit }) {
      commit("setIsOpenModalCompany", false);
      commit("setCompanyIDModal", "");
      commit("setCompanyDetail", { address: {} });
      commit("setLoadingUpdate", false);
      commit("setUploadLogoState", null);
      commit("setUploadCompanyStatus", null);
    },
    setUpdateCompanyEmpty({ commit }) {
      commit("setLoadingUpdate", false);
      commit("setUploadLogoState", null);
      commit("setUploadCompanyStatus", null);
    },
    updateCompanyPackage({ commit }, { companyId, packageObject }) {
      commit("setLoading", true);
      fc.companies
        .doc(companyId)
        .collection("PaymentSettings")
        .doc("plan")
        .set(packageObject, { merge: true })
        .then(function () {
          commit("setLoading", false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCompanyPlan({ commit, dispatch }, { companyID }) {
      fc.companies
        .doc(companyID)
        .collection("PaymentSettings")
        .doc("plan")
        .get()
        .then(function (companyPlan) {
          let plan = companyPlan.data();
          commit("setCompanyPlan", plan);
          if (plan && plan["paymentPlanID"])
            dispatch(
              "paymentPlans/getDetail",
              { paymentPlanID: plan["paymentPlanID"] },
              { root: true }
            );
          if (plan && plan["partnerID"])
            dispatch("getCompanyPartner", { partnerID: plan["partnerID"] });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCompanyNextPlan({ commit }, { companyID }) {
      fc.companies
        .doc(companyID)
        .collection("PaymentSettings")
        .doc("planNextMonth")
        .get()
        .then(function (companyNextPlan) {
          let nextPlan = companyNextPlan.data();
          commit("setCompanyNextPlan", nextPlan);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCompanyPartner({ commit }, { partnerID }) {
      fc.db
        .collection("Partners")
        .doc(partnerID)
        .get()
        .then(function (partnerDetail) {
          let detail = partnerDetail.data();
          detail.id = partnerDetail.id;
          commit("setRefCodeObject", detail);
        });
    },
    setAlertRefCode({ commit }, { alertRefCode }) {
      commit("setAlertRefCode", alertRefCode);
    },
    getCheckRefCode({ commit }, { newRefCode }) {
      fc.db
        .collection("Partners")
        .where("refCode", "==", newRefCode)
        .get()
        .then(function (partnerDetail) {
          if (partnerDetail.size === 1) {
            let partnerArray = [];
            partnerDetail.forEach((detail) => {
              let company = detail.data();
              company.id = detail.id;
              partnerArray.push(company);
            });
            commit("setRefCodeObject", partnerArray[0]);
            commit("setAlertRefCode", { isShow: true, alertStatus: "success" });
          } else {
            commit("setRefCodeObject", null);
            commit("setAlertRefCode", { isShow: true, alertStatus: "error" });
          }
        });
    },
    getCompanyUsage({ commit }, { companyID, date }) {
      fc.companies
        .doc(companyID)
        .collection("Usages")
        .doc(date)
        .get()
        .then(function (usageObject) {
          if (usageObject.exists) {
            let usage = usageObject.data();
            usage.id = usageObject.id;
            commit("setCompanyUsage", usage);
          }
        });
    },
    setEmptyCompanyDetail({ commit }) {
      commit("setCompanyDetail", { address: {} });
    },
    setCompanyAddress({ commit }, { address }) {
      commit("setCompanyAddress", address);
    },
    createCerRequest({ commit }, { companyID, cerRequestObject }) {
      commit("setLoading", true);
      fc.companies
        .doc(companyID)
        .collection("CerRequests")
        .doc()
        .set(cerRequestObject, { merge: true })
        .then(function () {
          commit("setLoading", false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCerRequest({ commit }, { companyID }) {
      commit("setLoading", false);
      fc.companies
        .doc(companyID)
        .collection("CerRequests")
        .orderBy("created", "desc")
        .get()
        .then(function (cerRequests) {
          if (cerRequests.size === 1) {
            let cerArray = [];
            cerRequests.forEach((cer) => {
              let companyCerRequest = cer.data();
              cerArray.push(companyCerRequest);
            });
            commit("setCompanyCerRequest", cerArray[0]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
